import { render, staticRenderFns } from "./PcpGiftView.vue?vue&type=template&id=ce52c27a&scoped=true"
import script from "./PcpGiftView.vue?vue&type=script&lang=js"
export * from "./PcpGiftView.vue?vue&type=script&lang=js"
import style0 from "./PcpGiftView.vue?vue&type=style&index=0&id=ce52c27a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce52c27a",
  null
  
)

export default component.exports